module.exports = __webpack_public_path__ + "static/media/deck-3-left.94a32471.png";